export const validationMessages = {
  ONLY_ALPHABETS: 'This Field Accepts Only Alphabets',
  ONLY_NUMBERS: 'Only Numbers allowed',
  INVALID_FORMAT: "Please enter valid format",
  US_PHONE_NUMBER: 'Please enter valid Phone Number',
  MIN_CHARACTERS: 'Please provide a brief description (minimum 50 characters).',
  MAX_CHARACTERS: 'Exceeded Minimum Characters',
  PLEASE_UPLOAD_VALID_DOC: 'Please upload valid document',
  BETWEEN_CHARACTERS: 'Characters should be between 5 to 10',
  PERCENTAGE: 'Please enter valid Percentage',
  EMAIL_ADDRESS: 'Please enter a valid email address',
  REQUIRED: 'This field is required',
  URL: 'Please enter a valid URL',
  ZIP_CODE: 'Please enter valid zip code',
  AGE_VALIDATION: 'The Age should be Above 18',
  ONLY_PDF_FILE: 'Please upload a PDF file',
  ONLY_CSV_FILE: 'Please upload a csv or excel file',
  NON_NEGATIVE: 'value should be greater than 0',
  GREATER_THAN_ZERO: 'Value must be greater than zero',
  TIN: 'Invalid Tax Identification Number(TIN)',
  PASSWORD_MATCH: "The passwords you entered don't match. Please try again.",
  PASSWORD_MATCH: "The passwords you entered don't match.",
  ACCOUNT_NUMBER: "Please enter valid account number",
  FUTURE_DATE: "Date cannot be in the future.",
  DOB: "Please select valid Date of Birth",
  DateError: "Please enter a valid input",
  INVALID_NAME: "Name contains invalid characters",
  PASSWORD: <ul>
    <li>Password must be 12-16 characters long.</li>
    <li>
      Must contain at least one lowercase letter, one uppercase letter, one digit, and one special character.
      (! @ # $ % ^ &amp; * ( ) - _ = + &#123; &#125; [ ] | \ : ; " ' &lt; &gt; , . ? /)
    </li>
    <li>Password must not begin or end with whitespace.</li>
  </ul>,
  USER_NAME: <ul>
    <li>Username must be at least 6 characters long.</li>
    <li>Username cannot exceed 35 characters.</li>
    <li>Username can only contain letters, numbers and one underscore (_)</li>
    <li>Username cannot contain more than 5 consecutive identical numbers</li>
    <li>Username Should contain at least one alphabet.</li>
    <li>Username Should not contain any Reserved or Foul Words</li>
  </ul>,
}
